export const MAX_COMMENT_LENGTH = 10_000;
export const MAX_MEDIA_COUNT = 15;

export const MAX_DOCUMENT_FILE_SIZE_IN_MEGABYTES = 25;
export const MAX_DOCUMENT_FILE_SIZE_IN_BYTES = MAX_DOCUMENT_FILE_SIZE_IN_MEGABYTES * 1024 * 1024;
